import { render } from "./cform3.vue?vue&type=template&id=cf1b9840&scoped=true"
import script from "./cform3.vue?vue&type=script&lang=js"
export * from "./cform3.vue?vue&type=script&lang=js"

import "./cform3.vue?vue&type=style&index=0&id=cf1b9840&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf1b9840"]])

export default __exports__